import React from 'react'
import SkeletonBlock from './SkeletonBlock'
import SkeletonText from './SkeletonText'
import SkeletonCard from './SkeletonCard'

/**
 * Mirrors the post-load Dashboard layout: Suggested CTA banner,
 * Quick Actions 2x2 grid, "Your Groups" heading + a couple of group cards.
 */
function DashboardSkeleton() {
  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Suggested CTA banner - matches the bg-accent block on Dashboard */}
        <div className="bg-accent/10 rounded-lg p-5 h-[88px]" aria-hidden="true" />

        {/* Quick Actions section heading + 2x2 tile grid */}
        <div>
          <SkeletonText className="w-32 h-4 mb-4" />
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {[0, 1, 2, 3].map((i) => (
              <SkeletonCard key={i} className="h-[112px]" />
            ))}
          </div>
        </div>

        {/* Your Groups header row + grid of cards */}
        <div>
          <div className="flex items-center justify-between mb-4">
            <div>
              <SkeletonText className="w-28 h-4 mb-2" />
              <SkeletonText className="w-40 h-3" />
            </div>
            <SkeletonText className="w-20 h-3" />
          </div>
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
            {[0, 1].map((i) => (
              <SkeletonCard key={i}>
                <SkeletonText className="w-2/3 h-4 mb-3" />
                <div className="flex gap-2 mb-4">
                  <SkeletonBlock className="w-12 h-5 rounded" />
                  <SkeletonBlock className="w-16 h-5 rounded" />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4 border-t border-border-subtle">
                  {[0, 1, 2].map((j) => (
                    <div key={j} className="flex items-center">
                      <SkeletonBlock className="w-8 h-8 rounded-lg mr-3" />
                      <div className="flex-1">
                        <SkeletonText className="w-8 h-3 mb-1" />
                        <SkeletonText className="w-16 h-2.5" />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex gap-3 pt-4">
                  <SkeletonBlock className="flex-1 h-11 rounded-lg" />
                  <SkeletonBlock className="flex-1 h-11 rounded-lg" />
                </div>
              </SkeletonCard>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardSkeleton
